module.exports = __webpack_public_path__ + "img/loading-logo.3fa10e5c.png";